<template>

  <el-main style="    overflow: auto;height: 86vh;">

    <el-dialog title="商品详情" :visible.sync="dialogVisible" :modal-append-to-body="false">
      <el-form  :inline="true" :model="ruleForm" :rules="rules" ref="ruleForm"  class="demo-form-inline">
        <el-form-item label="物料分类" prop="kindname">
          <el-input v-model="ruleForm.kindname"></el-input>
        </el-form-item>
          <el-form-item label="提前日期" prop="ahead">
            <el-input v-model="ruleForm.ahead"></el-input>
          </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-row>
      <el-col>
      <el-select v-model="selectedSale" @change="handleCheckedSaleChange" placeholder="请选择销售组织" clearable>
        <el-option v-for="saleOrg in saleOrgLists" :label="saleOrg.name" :key="saleOrg.id" :value="saleOrg.id"></el-option>
      </el-select>
      </el-col>
    </el-row>

    <el-row type="flex" class="row-bg" >
      <el-col :span="12">
        <el-col :span="6">
          <el-button type="warning"  size="small" @click="handleSave()" >保存</el-button>

        </el-col>
        <el-col>
        <el-tree  highlight-current :data="matLevel" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
        </el-col>
      </el-col>

      <el-col>
      <el-col :span="6">
      <el-button type="warning" icon="el-icon-plus" size="small" @click="handleAdd()" >新增</el-button>

      </el-col>

    <el-table
      highlight-current-row
      ref="singleTable"
      @current-change="handleCurrentChange"
      :data="tableData"
      style="width: 100%">
      <el-table-column
        label="物料类型"
        width="180">
        <template slot-scope="scope">

          <span style="margin-left: 10px">{{ scope.row.kindname }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="提前天数"
        width="180">
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="top">
            <p>姓名: {{ scope.row.name }}</p>
            <p>住址: {{ scope.row.address }}</p>
            <div slot="reference" class="name-wrapper">
              <el-tag size="medium">{{ scope.row.ahead }}</el-tag>
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
      </el-col>
    </el-row>
  </el-main>
</template>
<script>
  import {deleteByIds,getMaterialGroupLevel} from "@/api/system/material_group.js";
  import {updateBo} from "@/api/system/good.js";

  import {getOrgByAdmin} from "../../../api/system/org_sale";
  import {queryList,saveBo} from "@/api/system/matAhead.js";


  export default {
    data() {
      return {
        mat:{},
        selectedSale:'',
        tableData: [],
        ruleForm: {

        },
        currentRow: null,
        dialogVisible:false,
        currentUser:{},
        saleOrgLists:[],

        matLevel: [],
        defaultProps: {
          children: 'children',
          label: 'label'
        }
      };
    },
    mounted(){
      this.$refs.singleTable.setCurrentRow(this.tableData[2]);

      //获取当前用户
      this.currentUser = this.$store.getters.currentUser
      //获取用户对应销售组织
      this.getOrgByAdmin()
      this.queryList()
    },
    created() {

      // this.getMaterialGroupLevel()
    },
    methods: {

      setRow(row){
        console.log(row)
        // this.currentRow = row;
        this.$refs.singleTable.setCurrentRow(row);
      },
      handleEdit(index , row) {
        console.log(row)
        this.ruleForm = row;
        this.dialogVisible = true;
      },

    handleCurrentChange(val) {
        console.log(val)
      this.currentRow = val;
    },
      onSubmit(){
        saveBo(this.ruleForm).then(res =>{
          console.log(res)
          this.$alert('提交成功', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              this.dialogVisible = false;
              // this.$message({
              //   type: 'info',
              //   message: `action: ${ action }`
              // });
            }
          });
        })
      },
      queryList(){
        let param = {'kindname':'定制料'}
        queryList(param).then(res => {
          console.log(res.data)
          this.tableData = res.data
          console.log(this.tableData)


        }).catch(()=>{

        })
      },
      handleSave(){
        // this.currentItem = row;
        // this.currentItem.commerceVo.materialId = this.currentItem.id;
        // this.fileList = [];
        // this.ruleForm ={}
        // this.dialogVisible = true;
        // var  row = this.getrow()
        console.log(this.mat)
        console.log(this.currentRow)
        this.mat.matClass = this.currentRow.id
        this.mat.matClassname = this.currentRow.kindname

        updateBo(this.mat).then(res =>{
          console.log(res)
          this.$alert('提交成功', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              this.dialogVisible = false;
              // this.$message({
              //   type: 'info',
              //   message: `action: ${ action }`
              // });
            }
          });
        })
      },
      handleNodeClick(data) {
        var mat = data
        this.mat = mat
        console.log(mat.matClass)
        console.log(this.tableData)
        for(var i =0;i<this.tableData.length;i++){

            if(String(this.tableData[i].id) === String(mat.matClass)){
              console.log("ttttttttttt")
              console.log(i)
                this.setRow(this.tableData[i])
            }
        }
        console.log(data);
      },
      getOrgByAdmin(){
        let param = {'id':this.currentUser.id}
        getOrgByAdmin(param).then(res => {
          // console.log(res.data)
          this.saleOrgLists = res.data
          this.getMaterialGroupLevel()
        }).catch(()=>{

        })
      },
      handleCheckedSaleChange() {
        // this.saleOrgLists = this.selectedSale
        this.getMaterialGroupLevel(1)
      },
      getMaterialGroupLevel(data){
    // let param = {'id':this.currentUser.id}

        let params = {}
        if(this.selectedSale !== '') {
          params.orgSales = [{'id': this.selectedSale}]
        }
        else{
          params.orgSales = this.saleOrgLists

        }

        getMaterialGroupLevel(params).then(res => {
      console.log(res.data)
          this.matLevel = res.data


    }).catch(()=>{

    })
  }
    }
  };
</script>
